import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=2ad344de&scoped=true&"
import script from "./addOrEdit.vue?vue&type=script&lang=js&"
export * from "./addOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=2ad344de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad344de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ad344de')) {
      api.createRecord('2ad344de', component.options)
    } else {
      api.reload('2ad344de', component.options)
    }
    module.hot.accept("./addOrEdit.vue?vue&type=template&id=2ad344de&scoped=true&", function () {
      api.rerender('2ad344de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicFiles/components/addOrEdit.vue"
export default component.exports